import React from "react";

/**
 * WelcomeMessage - Personalized welcome message component
 *
 * @param {Object} props
 * @param {Object} props.user - User data object
 */
const WelcomeMessage = ({ user }) => {
  if (!user) return null;

  // Calculate time since last sign-in
  const lastSignIn = user.lastSignIn ? new Date(user.lastSignIn) : new Date();
  const timeAgo = Math.floor((new Date() - lastSignIn) / (1000 * 60 * 60));

  return (
    <div className="p-4 mb-4 rounded-md bg-[#1a1e21]/70 border border-[#4db1e0]/30 animate-in fade-in duration-500">
      <p className="text-center text-white">
        Welcome back,{" "}
        <span className="font-bold text-[#4db1e0]">
          {user.firstName || user.email.split("@")[0]}
        </span>
        !
        {timeAgo < 24 && (
          <span className="text-gray-300"> ({timeAgo}h ago)</span>
        )}
      </p>
    </div>
  );
};

export default WelcomeMessage;
